import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/useAuth';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-paper flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate">
          <div className="w-5 h-5 border-2 border-cloud border-t-red-500 animate-spin" />
          Loading Scalent...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
